export default __webpack_public_path__ + "static/media/IMG_7091.64b33956.jpg";